import React from 'react';
import {
  Package, UtensilsCrossed, Users, DollarSign, Clock, CheckCircle, ChefHat, Truck,
  TrendingUp, Plus, Edit, Trash2, GripVertical, ArrowUp, ArrowDown, FolderOpen,
  Upload, Image, Star, MessageSquare, Mail, Eye, Reply, Send, Megaphone, Tag, Calendar, X, ChevronLeft
} from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { TabsContent } from '../ui/tabs';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../ui/dialog';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Switch } from '../ui/switch';
import { toast } from 'sonner';
import { apiRequest, formatPrice, getAuthToken } from '../../lib/utils';

const OverviewTab = ({
  stats,
}) => (
          <TabsContent value="overview">
            {stats && (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                <Card className="bg-[#141417] border-[#27272A]">
                  <CardHeader className="flex flex-row items-center justify-between pb-2">
                    <CardTitle className="text-sm font-medium text-zinc-400">Total Revenue</CardTitle>
                    <DollarSign className="h-5 w-5 text-[#FFC107]" />
                  </CardHeader>
                  <CardContent>
                    <div className="text-2xl font-bold text-[#FFC107]">{formatPrice(stats.total_revenue)}</div>
                  </CardContent>
                </Card>

                <Card className="bg-[#141417] border-[#27272A]">
                  <CardHeader className="flex flex-row items-center justify-between pb-2">
                    <CardTitle className="text-sm font-medium text-zinc-400">Total Orders</CardTitle>
                    <Package className="h-5 w-5 text-blue-500" />
                  </CardHeader>
                  <CardContent>
                    <div className="text-2xl font-bold">{stats.total_orders}</div>
                    <p className="text-xs text-zinc-500">{stats.pending_orders} pending</p>
                  </CardContent>
                </Card>

                <Card className="bg-[#141417] border-[#27272A]">
                  <CardHeader className="flex flex-row items-center justify-between pb-2">
                    <CardTitle className="text-sm font-medium text-zinc-400">Menu Items</CardTitle>
                    <UtensilsCrossed className="h-5 w-5 text-green-500" />
                  </CardHeader>
                  <CardContent>
                    <div className="text-2xl font-bold">{stats.total_items}</div>
                  </CardContent>
                </Card>

                <Card className="bg-[#141417] border-[#27272A]">
                  <CardHeader className="flex flex-row items-center justify-between pb-2">
                    <CardTitle className="text-sm font-medium text-zinc-400">Customers</CardTitle>
                    <Users className="h-5 w-5 text-purple-500" />
                  </CardHeader>
                  <CardContent>
                    <div className="text-2xl font-bold">{stats.total_users}</div>
                  </CardContent>
                </Card>
              </div>
            )}
          </TabsContent>
);

export default OverviewTab;
